import { AnyAction } from "redux";

import * as types from "./types";

import { initialState } from ".";

export default function clusterGraphReducer(
  state = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case types.GENERATE_CLUSTER_GRAPH: {
      return {
        ...state,
        isDataLoading: action.payload.isDataLoading,
      };
    }
    case types.GENERATE_CLUSTER_SUCCESS: {
      return {
        ...state,
        isDataLoading: action.payload.isDataLoading,
        clusterGraphData: { ...action.payload.clusterGraphData },
      };
    }
    case types.GENERATE_CLUSTER_ERROR: {
      return {
        ...state,
        isFetchingOrigin: false,
        hasErrorLoadingData: action.payload.hasErrorLoadingData,
      };
    }
    case types.OPEN_GRAPH_MODAL: {
      return {
        ...state,
        isGraphModalOpen: action.payload.isGraphModalOpen,
      };
    }
    default:
      return state;
  }
}
